import { useParams } from "common/components/Form/ParamsContext";
import { getCouponService } from "./couponApi";

export default function useCouponList() {
  const params = useParams<"partner_id">();
  const scope = { partners: params.partner_id };
  const editUrl =
    Object.values(scope || {}).filter(Boolean).length > 0 ? "coupons/" : "";
  const service = getCouponService(scope);

  return { ...service, params, scope, editUrl };
}
